var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5C0 0.223858 0.223858 0 0.5 0H12.6097C12.8859 0 13.1097 0.223858 13.1097 0.5V6.54273L7.8872 5.38217C6.38674 5.04873 5.04822 6.38727 5.38165 7.88772L6.5421 13.1097H0.5C0.223858 13.1097 0 12.8859 0 12.6097V0.5ZM7.33161 7.42914C7.3314 7.43717 7.33217 7.44543 7.33402 7.45379L8.5909 13.1097L7.33402 7.45385C7.33216 7.44547 7.33139 7.43719 7.33161 7.42914Z",
    fill: "#3F4D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9133 9.59414C16.9691 9.53834 16.9413 9.44293 16.8643 9.42581L7.45334 7.33448C7.38189 7.3186 7.31815 7.38234 7.33402 7.45379L9.42535 16.8648C9.44247 16.9418 9.53788 16.9696 9.59368 16.9138L12.4251 14.0824C12.4641 14.0433 12.5274 14.0433 12.5665 14.0824L15.456 16.9719C15.495 17.0109 15.5583 17.0109 15.5974 16.9719L16.9714 15.5979C17.0105 15.5588 17.0105 15.4955 16.9714 15.4564L14.0819 12.5669C14.0429 12.5279 14.0429 12.4646 14.0819 12.4255L16.9133 9.59414Z",
    fill: "#3F4D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelections);
export default __webpack_public_path__ + "static/media/selections.6cb606efef43a3fe6196c1d0a4cdb3df.svg";
export { ForwardRef as ReactComponent };